export const abreviacaoEmpresa = (empresa) => {
  empresa = empresa?.toUpperCase()?.trim()

  const empresas = {
    'INNOVATION COMERCIO DE BRINDES': 'INNOVATION',
    'YOUNG INDUSTRIA E COMERCIO DE BRINDES': 'YOUNG',
    'INNOVATION COMERCIO DE PRESENTES': 'PRESENTES',
    'I & V COMERCIO DE BRINDES EIRELI': 'I & V',
    'J & M COMERCIO DE BRINDES EIRELI': 'J & M',
    'D & T COMERCIO DE BRINDES EIRELI': 'D & T',
    'D T COMERCIO DE BRINDES EIRELI': 'D T',
    'MP PRESTACOES DE SERVICOS LTDA': 'MP',
  }

  return empresas[empresa] || empresa
}
